import React, { Component } from 'react';
import { Button, Popconfirm, message } from 'antd';
import UpdateModal from './UpdateLanguage';
import ComTable from '../ComTable';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class Language extends Component {
    state = {
        data: [],
        config: [],
        pagination: {
            offset: 1,
            pageSize: 10,
        },
        loading: false,
    }

    componentDidMount() {
        const config = [{
            zh: '语种',
            en: 'Language',
            key: 'language',
            width: 240,
        }, {
            zh: '说',
            en: 'Speaking',
            key: 'speak',
        }, {
            zh: '读',
            en: 'Reading',
            key: 'read',
        }, {
            zh: '写',
            en: 'Writing',
            key: 'write',
        }];
        this.setState({ config }, () => {
            this.loadData();
        });
    }

    loadData = () => {
        const { userId, isChinese } = this.props;
        const { pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.personal.queryVitaeLanguageList,
            data: {
                userId,
                offset: current,
                limit: pageSize,
                type: isChinese ? 'CHINESE' : 'ENGLISH',
            },
            dataType: 'json',
            doneResult: res => {
                const { vitaeLanguageList = [], totalCount = 0 } = res;
                pagination.total = totalCount;

                this.setState({
                    pagination,
                    loading: false,
                    data: vitaeLanguageList,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    update = (record) => {
        this.ref.show(record);
    }

    delete = (row) => {
        const { vitaeLanguageId } = row;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.personal.delVitaeLanguage,
            data: { vitaeLanguageId },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleTableChange = ({ pagination }) => {
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    getOperate = () => {
        const { isChinese } = this.props;
        return {
            title: isChinese ? '操作' : 'Operation',
            key: 'operate',
            width: 80,
            render: (text, row) => {
                return (
                    <span>
                        <a onClick={() => this.update(row)}>修改</a>
                        {
                            isChinese ? 
                                <span>
                                    <span className="ant-divider" />
                                    <Popconfirm title="确定要删除吗?" onConfirm={() => this.delete(row)}>
                                        <a>删除</a>
                                    </Popconfirm>
                                </span>
                            :
                             null
                        }
                    </span>
                );
            }
        };
    }

    getDataSource = () => {
        const { data } = this.state;
        const { isChinese } = this.props;
        const dataSource = data.map((item, index) => {
            const {
                languageName,
                languageNameEnglish,
                languageOtherChinese,
                languageOtherEnglish,
                speakingName,
                speakingNameEnglish,
                readingName,
                readingNameEnglish,
                writingName,
                writingNameEnglish,
            } = item;
            const languageOther = isChinese ? languageOtherChinese : languageOtherEnglish;
            return {
                index: index + 1,
                ...item,
                language: `${isChinese ? languageName : languageNameEnglish}${languageOther ? `(${languageOther})` : ''}`,
                speak: isChinese ? speakingName : speakingNameEnglish,
                read: isChinese ? readingName : readingNameEnglish,
                write: isChinese ? writingName : writingNameEnglish,
            }
        });
        return dataSource;
    }

    render() {
        const { userId, canEdit, isChinese } = this.props;
        const { data, config, loading, pagination } = this.state;
        const result = config.map(item => {
            if (isChinese) {
                item.title = item.zh;
            } else {
                item.title = item.en;
            }
            return item;
        });
        canEdit && result.push(this.getOperate());
        return (
            <div>
                { isChinese && canEdit && <Button type="primary" onClick={() => this.update()}>新增</Button> }
                <div style={{ marginTop: 20 }}>
                    <ComTable
                        data={data}
                        config={result}
                        loading={loading}
                        pagination={pagination}
                        getDataSource={this.getDataSource}
                        onChange={(params) => this.handleTableChange(params)}
                    />
                </div>
                <UpdateModal ref={el => this.ref = el} userId={userId} isChinese={isChinese} loadData={this.loadData} />
            </div>
        );
    }
}

export default Language;


// WEBPACK FOOTER //
// ./src/components/common/curriculumVitae/Language.js